import React, { ReactNode } from "react";
import { Box, CardHeader, Grid, makeStyles } from "@material-ui/core";

import AvatarBadge from "./AvatarBadge";
import {
  MemberStatus,
  memberStatusColor,
} from "../../../settings/MemberStatus";
import { Status } from "./Status";

interface AvatarHeaderProps {
  avatar: string;
  alt?: string;
  title: ReactNode;
  subTitle: ReactNode;
    size?: number;

  validationStatus: MemberStatus;
  accountStatus?: MemberStatus;
}

const useStyles = makeStyles(
  (theme) => ({
    header: {
    },

    cardHeaderTitle: {
      fontSize: 18,
    },

    cardHeader: {
      padding: 0,
    },
  }),
  { name: "avatar-header-styles" }
);

export default function AvatarHeader(props: AvatarHeaderProps) {
  const classes = useStyles();
  // Props
  const {
    title,
    subTitle,
    validationStatus,
    accountStatus,
    avatar,
    alt,
      size,
  } = props;

  return (
    <Grid container className={classes.header}>
      <Grid item xs={9}>
        <CardHeader
          className={classes.cardHeader}
          avatar={
            <AvatarBadge
                size={size}
              color={memberStatusColor(validationStatus, 500)}
              alt={alt}
              src={avatar}
            />
          }
          title={title}
          subheader={subTitle}
        />
      </Grid>
      <Grid item xs={1} />
      <Grid item xs={2}>
        <Box
          component="div"
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          pt={1}
        >
          {accountStatus !== null ? (
            <Status withBorder withUppercase size={11} status={accountStatus} />
          ) : (
            <></>
          )}

          <Box component="div" ml={2}>
            <Status
              withBorder
              withUppercase
              size={11}
              status={validationStatus}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
